import { styled } from 'styled-system/jsx'

const PageShell = styled('main', {
  base: {
    minHeight: '100vh',
    backgroundColor: 'app.bg',
    color: 'app.fg',
    paddingX: { base: '16px', md: '32px' },
    paddingY: { base: '24px', md: '48px' },
    display: 'flex',
    justifyContent: 'center',
  },
})

const Centered = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fgMuted',
    paddingY: '64px',
    textAlign: 'center',
    maxWidth: '480px',
  },
})

const ErrorState = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'book.danger',
    paddingY: '64px',
    maxWidth: '480px',
    textAlign: 'center',
  },
})

const Card = styled('div', {
  base: {
    width: '100%',
    maxWidth: '560px',
    backgroundColor: 'app.surface',
    borderRadius: 'lg',
    border: '1px solid',
    borderColor: 'app.border',
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06)',
    padding: { base: '24px', md: '32px' },
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
  },
})

const Heading = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: { base: '22px', md: '26px' },
    fontWeight: 600,
    margin: 0,
  },
})

const Lead = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fgMuted',
    margin: 0,
    lineHeight: 1.5,
  },
})

const BookingSummaryPanel = styled('div', {
  base: {
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'md',
    padding: '14px 16px',
    backgroundColor: 'book.surfaceMuted',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
})

const SummaryLabel = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: 600,
    color: 'app.fgMuted',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
})

const SummaryValue = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fg',
  },
})

const FieldLabel = styled('label', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: 600,
    color: 'app.fgMuted',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
})

const ReasonTextarea = styled('textarea', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    padding: '10px 12px',
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'md',
    backgroundColor: 'app.surface',
    color: 'app.fg',
    minHeight: '88px',
    resize: 'vertical',
    _focus: {
      outline: 'none',
      borderColor: 'app.accent',
      boxShadow: '0 0 0 3px rgba(31, 111, 235, 0.15)',
    },
  },
})

const ButtonRow = styled('div', {
  base: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
  },
})

const SecondaryButton = styled('a', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: 500,
    padding: '10px 16px',
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'md',
    backgroundColor: 'app.surface',
    color: 'app.fg',
    textDecoration: 'none',
    cursor: 'pointer',
    _hover: { backgroundColor: 'book.surfaceMuted' },
  },
})

const DangerButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: 600,
    padding: '10px 20px',
    border: 'none',
    borderRadius: 'md',
    backgroundColor: 'book.danger',
    color: 'white',
    cursor: 'pointer',
    _hover: { filter: 'brightness(0.92)' },
    _disabled: { opacity: 0.5, cursor: 'not-allowed' },
  },
})

const CancelledHeadline = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '22px',
    fontWeight: 600,
    margin: 0,
  },
})

const CancelledSubline = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fgMuted',
    margin: 0,
    lineHeight: 1.5,
  },
})

export {
  PageShell,
  Centered,
  ErrorState,
  Card,
  Heading,
  Lead,
  BookingSummaryPanel,
  SummaryLabel,
  SummaryValue,
  FieldLabel,
  ReasonTextarea,
  ButtonRow,
  SecondaryButton,
  DangerButton,
  CancelledHeadline,
  CancelledSubline,
}
